import { Loader2 } from 'lucide-react';

export const LoadingFallback = () => (
    <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-label="페이지 로딩 중" />
    </div>
);
